<template>
    <div class="container" v-if="newsList">
        <div class="news-list">
            <ul>
                <li v-for="(item, index) in newsList.list" :key="index">
                    <img :src="imgsList[index]" alt />
                    <router-link
                        :to="'/news/' + item.articleId"
                        :title="item.title"
                        target="_blank"
                    >{{item.title}}</router-link>
                    <div class="time">{{item.updateTime}}</div>
                </li>
            </ul>

            <div class="pagination">
                <el-pagination
                    v-if="newsList && newsList.list.length > 0"
                    background
                    layout="prev, pager, next,total"
                    :total="newsList.count"
                    :page-size="newsList.pageSize"
                    :current-page="newsList.page"
                    @current-change="handleCurrentChange"
                ></el-pagination>
            </div>
        </div>
        <Hot></Hot>
    </div>
</template>

<script>
import * as apis from '../fetch/common';
import Hot from '../components/hot/Hot';

export default {
    name: 'news-list',
    components: {
        Hot,
    },
    data() {
        return {
            newsList: null,
            imgsList: [
                require('../assets/news-index1.png'),
                require('../assets/news-index2.png'),
                require('../assets/news-index3.png'),
                require('../assets/news-index4.png'),
                require('../assets/news-index5.png'),
                require('../assets/news-index6.png'),
                require('../assets/news-index7.png'),
                require('../assets/news-index8.png'),
                require('../assets/news-index9.png'),
                require('../assets/news-index10.png'),
            ],
        };
    },
    methods: {
        handleCurrentChange(page) {
            this.getNewsList(page);
        },
        getNewsList(page = 1) {
            apis.getArticleList('news', page).then(res => (this.newsList = res));
        },
    },
    mounted() {
        this.getNewsList();
    },
};
</script>

<style lang="less" scoped>
.container {
    display: flex;
    justify-content: space-between;
}

.news-list {
    width: 895px;
    margin-right: 18px;
    ul {
        margin-top: 0;
        padding-left: 0px;
        li {
            list-style: none;
            background-color: #fff;
            margin-bottom: 10px;
            height: 60px;
            box-shadow: 0px 0px 20px 0px rgba(228, 228, 228, 0.5);
            border-radius: 10px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            padding-right: 20px;
            img {
                width: 60px;
                margin-top: 24px;
                margin-right: 40px;
            }
            a {
                flex: 1;
                font-size: 16px;
                color: #2b2b2b;
            }
            .time {
                color: #8b8b8b;
                font-size: 14px;
                width: 170px;
                text-align: right;
            }
        }
    }
}
</style>